import React, { type ComponentProps } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { type Container, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationSelectedIngredientsContainer = (
  props: CustomizationSelectedIngredientsContainerProps,
) => {
  const { children, style, wrapperStyle, ...restProps } = props;

  const { currentBreakpoint, match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const outerContainerStyles = [
    styles.outerContainer,
    match([styles.outerContainerXS, styles.outerContainerSM]),
    wrapperStyle,
  ];

  const contentContainerStyles = [
    styles.contentContainer,
    match([styles.contentContainerXS]),
    style,
  ];

  // ─────────────────────────────────────────────────────────────────────

  // NOTE: In the sidebar, the list is not inset by the bottom safe area, so
  //       its scroll indicator should reach the bottom edge as well.
  return (
    <View style={outerContainerStyles} {...restProps}>
      <ScrollView
        contentContainerStyle={contentContainerStyles}
        automaticallyAdjustsScrollIndicatorInsets={currentBreakpoint.isXS}
      >
        {children}
      </ScrollView>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  outerContainerXS: {},
  outerContainerSM: {
    paddingHorizontal: theme.spacing['4'],
  },
  contentContainer: {
    rowGap: theme.spacing['4'],
  },
  contentContainerXS: {
    paddingBottom: theme.spacing['30'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationSelectedIngredientsContainerProps = ComponentProps<typeof Container>;
